export const ROLES = {
  GUEST: 'guest',
  ADMIN: 'administrator',
};
